import { combineLatest, map, of, switchMap } from 'rxjs';
import { memo } from '../util/index.js';
/**
 * @description Get the candidate info for a society
 */
export function candidates(instanceId, api) {
  return memo(instanceId, () => api.query.society.candidates().pipe(switchMap(candidates => combineLatest([of(candidates), api.query.society.suspendedCandidates.multi(candidates.map(_ref => {
    let {
      who
    } = _ref;
    return who;
  }))])), map(_ref2 => {
    let [candidates, suspended] = _ref2;
    return candidates.map((_ref3, index) => {
      let {
        kind,
        value,
        who
      } = _ref3;
      return {
        accountId: who,
        isSuspended: suspended[index].isSome,
        kind,
        value
      };
    });
  })));
}